import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #191919;
  color: #e4d9d9;
  font-size: 9px;
  font-weight: 400;
  padding: 16px 0;
  text-align: center;
  position: relative;
  width: 100%;
  flex-shrink: 0;
  margin-top: auto;
  letter-spacing: 2px;
`;
